











































import { Vue, Component } from 'vue-property-decorator'
import { PLAYER_TYPE, RESPONSE_PAUSE_CODE } from '../store/enums'
import ScriptLine from '../components/ScriptLine.vue'

@Component({
  components: {
    ScriptLine,
  },
  computed: {
    playerTypeClass() {
      return this.$store.state.engine.playerType == PLAYER_TYPE.AUTO_DIALOG ? 'dialog' : 'two_cl'
    },
    loadingClass() {
      if ((this as any).isTransitioning) { return 'isTransitioning' }
      return this.$store.state.engine.playerType == PLAYER_TYPE.AUTO_DIALOG && (this as any).isLoading ? 'isLoading' : ''
    },
    latestLogs() {
      if (this.$store.state.engine.playerType == PLAYER_TYPE.AUTO_DIALOG) {
        return (this as any).logs.slice(-1)
      } else {
        return (this as any).logs
      }
    },
    currentVocabTerm() {
      if (this.$store.state.vocab.earnedWords.indexOf((this as any).currentVocabStar) !== -1) {
        return this.$store.state.vocab.words[(this as any).currentVocabStar]
      }
      return { id: (this as any).currentVocabStar, term: "???", definition: "(vocab star is locked)" }
    },
  },
  created() {
    document.addEventListener('keyup', (this as any).handleKeyPress)
  },
  destroyed() {
    document.removeEventListener('keyup', (this as any).handleKeyPress)
  },
})
export default class PlayerPage extends Vue {
  logs: any[] = []
  isLoading: boolean = false
  isTransitioning: boolean = false
  manualWaitCodes: RESPONSE_PAUSE_CODE[] = [
    RESPONSE_PAUSE_CODE.DIALOGUE,
    RESPONSE_PAUSE_CODE.VOCAB_GET,
    RESPONSE_PAUSE_CODE.SCRIPT_END
  ]
  haltCodes: RESPONSE_PAUSE_CODE[] = [
    RESPONSE_PAUSE_CODE.ERR_UNKNOWN_MACRO,
    RESPONSE_PAUSE_CODE.ERR_MISSING_SCRIPT,
  ]
  titleBuffer: any[] = []
  isTitleShowing: boolean = false
  choiceBuffer: any[] = []
  choiceToVar: string = ''
  isChoicesShowing: boolean = false
  isPromptShowing: boolean = false
  isVocabShowing: boolean = false
  promptOptions = {
    toVar: '',
    prompt: '',
    value: '',
  }
  currentVocabStar = 1

  beforeRouteLeave(to: any, from: any, next: any) {
    next(false)
  }

  async addResponse(response: any, shouldPush: boolean = true) {
    if (response.code === RESPONSE_PAUSE_CODE.TITLE_ADD_BUFFER) {
      this.titleBuffer.push(response.body)
    } else if (response.code === RESPONSE_PAUSE_CODE.CHOICE_ADD_BUFFER) {
      this.choiceBuffer.push(response.body)
    } else if (response.code === RESPONSE_PAUSE_CODE.TITLE_POP) {
      // Handle showing the title using the buffer
      // then clear it!
      await new Promise((resolve) => {
        const totalDur = response.body.duration + response.body.trans_in + response.body.trans_out
        this.isTransitioning = true
        this.isTitleShowing = true
        setTimeout(() => {
          this.isTitleShowing = false
        }, response.body.duration + response.body.trans_in)
        setTimeout(() => {
          this.titleBuffer = []
          this.isTransitioning = false
          setTimeout(() => resolve(true), 500)
        }, totalDur)
      })
    } else if (response.code === RESPONSE_PAUSE_CODE.LOG_CLEAR) {
      this.logs = []
    } else if (response.code === RESPONSE_PAUSE_CODE.PROMPT_ASK_STRING) {
      this.promptOptions.toVar = response.body.toVar
      this.promptOptions.prompt = response.body.prompt
      this.isPromptShowing = true
    } else if (response.code === RESPONSE_PAUSE_CODE.PROMPT_ASK_CHOICE) {
      this.choiceToVar = response.body.toVar
      this.isChoicesShowing = true
    } else if (response.code === RESPONSE_PAUSE_CODE.ERR_MISSING_SCRIPT) {
      this.choiceBuffer = [
        { value: "#!FDOWNLOAD", caption: "Attempt Force Download" },
        { value: "#!RETURNHOME", caption: "Return Home" }
      ]
      this.isChoicesShowing = true
    } else if (response.code === RESPONSE_PAUSE_CODE.SCRIPT_END) {
      this.choiceBuffer = [
        { value: "#!STARTFCH0", caption: "Replay the Game" },
        { value: "#!RETURNHOME", caption: "Quit and Return Home" }
      ]
      this.isChoicesShowing = true
    }

    if (shouldPush) { this.logs.push(response) }
  }

  handleKeyPress(event: any) {
    event.preventDefault()
    if (event.code == 'KeyS' && !this.isPromptShowing) {
      this.isVocabShowing = !this.isVocabShowing
    } else if (event.code == 'ArrowLeft' && this.isVocabShowing) {
      if (this.currentVocabStar <= 1) { this.currentVocabStar = Object.keys(this.$store.state.vocab.words).length }
      else { this.currentVocabStar -= 1 }
    } else if (event.code == 'ArrowRight' && this.isVocabShowing) {
      if (this.currentVocabStar >= Object.keys(this.$store.state.vocab.words).length) { this.currentVocabStar = 1 }
      else { this.currentVocabStar += 1 }
    } else if (event.key == 'Enter' || event.key == ' ') {
      this.nextLine()
    }
  }

  handleChoicePress(choice: string) {
    if (choice.startsWith("#!")) {
      if (choice == "#!FDOWNLOAD") {
        this.$store.commit('SET_CURRENT_FILE', this.$store.state.engine.initFile)
        this.$store.commit('SET_CURRENT_LINE', 0)
        this.$store.dispatch('M_INIT', (this as any).$gapi).then(() => {
          this.choiceBuffer = []
          this.isChoicesShowing = false
          this.nextLine()
        })
      } else if (choice == "#!RETURNHOME") {
        this.$router.push('start')
      } else if (choice == "#!STARTFCH0") {
        this.$store.commit('SET_CURRENT_FILE', "CHAPTER0.PAPSYS")
        this.$store.commit('SET_CURRENT_LINE', 0)
        this.nextLine()
      }
    } else {
      this.$store.commit('VARIABLE_UPDATE', {
        id: this.choiceToVar,
        value: choice,
      })  
    }
    
    this.choiceBuffer = []
    this.isChoicesShowing = false
  }

  handlePromptAnswer() {
    if (!this.promptOptions.value || !this.isPromptShowing) { return }

    this.$store.commit('VARIABLE_UPDATE', {
      id: this.promptOptions.toVar,
      value: this.promptOptions.value,
    })
    // reset the buffer
    this.promptOptions = { toVar: '', prompt: '', value: '' }
    this.isPromptShowing = false
  }

  async nextLine() {
    if (this.isLoading || this.isChoicesShowing || this.isPromptShowing) { return }

    this.isLoading = true
    const response = await this.$store.dispatch('NEXT_LINE')

    if (this.haltCodes.indexOf(response.code) !== -1) {
      await this.addResponse(response)
      this.isLoading = false
      return
    }

    if (this.manualWaitCodes.indexOf(response.code) !== -1) {
      await this.addResponse(response)
      this.isLoading = false

      /* if (this.$store.state.engine.playerType == PLAYER_TYPE.AUTO_DIALOG) {
        setTimeout(this.nextLine, 5000)
      } */
    } else {
      await this.addResponse(response, false)
      this.isLoading = false
      this.nextLine()
    }
  }

  mounted() {
    this.nextLine()
  }
}
